module.exports = __webpack_public_path__ + "static/media/MenuBurger.9fc15675.jpg";